import React from 'react';

// This is Facebook's logo, you are not allowed to change its color
export const FacebookLogo = ({ ariaLabelledBy }) => (
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={ariaLabelledBy}
  >
    <path
      d="M7.89.214C4.055 1.047 1.005 4.13.205 7.947c-.734 3.45.533 7.283 3.166 9.6.967.85 3.2 2.033 4.15 2.183l.617.1v-6.883H5.806v-3h2.283l.083-1.633c.134-2.417.717-3.534 2.3-4.25.617-.284 1.034-.35 2.3-.334.85.017 1.617.084 1.7.134.1.05.167.7.167 1.433v1.317h-.983c-1.484 0-1.75.283-1.817 1.983l-.067 1.35h1.45c1.284 0 1.434.033 1.35.283-.05.167-.133.667-.2 1.134-.216 1.55-.25 1.583-1.483 1.583h-1.083V19.914l.866-.234c1.684-.433 2.984-1.216 4.4-2.633 2.067-2.067 2.9-4.1 2.9-7.017 0-3.166-1.2-5.75-3.616-7.766C14.106.38 10.772-.42 7.889.214z"
      fill="#1877F2"
      fillRule="nonzero"
    />
  </svg>
);

// This is Google's logo, you are not allowed to change its color
export const GoogleLogo = ({ ariaLabelledBy }) => (
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={ariaLabelledBy}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 01-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.35z"
        fill="#4285F4"
      />
      <path
        d="M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0010 20z"
        fill="#34A853"
      />
      <path
        d="M4.405 11.9c-.2-.6-.314-1.24-.314-1.9 0-.66.114-1.3.314-1.9V5.51H1.064A9.996 9.996 0 000 10c0 1.614.386 3.14 1.064 4.49l3.34-2.59z"
        fill="#FBBC05"
      />
      <path
        d="M10 3.977c1.468 0 2.786.505 3.823 1.496l2.868-2.868C14.959.99 12.695 0 10 0 6.09 0 2.71 2.24 1.064 5.51l3.34 2.59C5.192 5.736 7.396 3.977 10 3.977z"
        fill="#EA4335"
      />
      <path d="M0 0h20v20H0z" />
    </g>
  </svg>
);

// This is VocaTales's logo, you can change its color if you like
export const VocaTalesLogo = ({ ariaLabelledBy }) => (
  <svg width="30" height="24" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.96251 3.76971H33.0377C33.5676 3.76971 34.0924 3.87411 34.582 4.07693C35.0716 4.27976 35.5164 4.57705 35.8911 4.95182C36.2657 5.32658 36.5629 5.77149 36.7656 6.26112C36.9683 6.75076 37.0726 7.27553 37.0725 7.80547V22.0793C37.0729 22.6094 36.9688 23.1344 36.7662 23.6242C36.5636 24.1141 36.2665 24.5592 35.8918 24.9342C35.5171 25.3092 35.0721 25.6066 34.5824 25.8096C34.0927 26.0125 33.5678 26.117 33.0377 26.117H26.6133V23.9057H26.6564L29.6622 22.0795V18.3831H26.5214V19.7907H25.1168V18.3831H21.976V19.7907H20.5724V18.3831H17.4287V19.7907H16.0271V18.3831H12.8834V19.7907H11.4827V18.3831H8.33801V22.0795L11.3868 23.9057V26.117L3.96286 31.8165V31.8195L3.83375 31.9173C3.74026 31.9714 3.63418 31.9999 3.52617 32C3.41816 32.0001 3.31203 31.9718 3.21845 31.9178C3.12487 31.8639 3.04713 31.7863 2.99306 31.6928C2.93898 31.5993 2.91047 31.4932 2.9104 31.3852V25.5555C1.72393 24.8533 0.927734 23.5602 0.927734 22.0793V7.80547C0.927606 7.27553 1.03187 6.75076 1.23458 6.26112C1.43729 5.77149 1.73447 5.32658 2.10915 4.95182C2.48382 4.57705 2.92866 4.27976 3.41824 4.07693C3.90783 3.87411 4.43257 3.76971 4.96251 3.76971ZM8.24411 17.5058L11.0073 11.2301L13.7695 17.5058H8.24411ZM24.2316 17.5058L26.9938 11.2301L29.757 17.5058H24.2316ZM16.2393 10.383L19.0016 4.10737L21.7618 10.383H16.2393ZM21.6953 17.5733H16.3088V13.2881L15.3023 12.5564V11.2262H22.6989V12.5564L21.6953 13.2881V17.5733Z" fill="#FFF" />
    <path d="M22.7781 2.42752C24.0193 2.59194 25.2443 2.7542 26.6476 1.66283C25.1942 1.91038 24.086 1.36133 23.0115 0.82906C21.7851 0.221459 20.6027 0.364284 19.0016 0.281709V3.04492C20.3888 2.11103 21.5909 2.27026 22.7781 2.42752Z" fill="#FFF" />
    <path fillRule="evenodd" clipRule="evenodd" d="M19.0016 12.6972C18.3746 12.6972 17.8669 13.2058 17.8669 13.8318V16.0991H20.1342V13.8318C20.1342 13.2058 19.6266 12.6972 19.0016 12.6972ZM18.6954 21.1922C18.3721 21.1921 18.0519 21.2557 17.7531 21.3794C17.4544 21.503 17.1829 21.6844 16.9543 21.913C16.7256 22.1417 16.5443 22.4131 16.4206 22.7119C16.2969 23.0106 16.2333 23.3308 16.2335 23.6542V26.1151H21.1574V23.6542C21.1571 23.0013 20.8976 22.3752 20.436 21.9136C19.9743 21.4519 19.3483 21.1925 18.6954 21.1922Z" fill="#FFF" />
  </svg>
);